import React from 'react';
import { View } from 'react-native';
import { StopPropagationBoundary } from '../StopPropagationBoundary';

import './PortalOverlayDialog.module.scss';

export type PortalOverlayModalProps = {
  children: React.ReactNode | React.ReactNode[];
  position?: 'small';
};

export default function PortalOverlayDialog({
  children,
  position = 'small',
}: PortalOverlayModalProps) {
  return (
    <View styleName={`overlayDialog ${position}`} pointerEvents="auto">
      <StopPropagationBoundary>
        {children}
      </StopPropagationBoundary>
    </View>
  );
}
